module.exports = __webpack_public_path__ + "img/naar-en-ven-3.c8d3b004.png";